import { FilterOption } from '../../utils/filter-options';

export type DashboardClause = 'gp' | 'new';

export const DEFAULT_GP_CAMPAIGN_YEARS = [2023, 2024, 2025, 2026] as const;

export const DEFAULT_NGP_CAMPAIGN_YEARS = [2025, 2026, 2027] as const;

export type PratiquesSynthesisOwnerOption = FilterOption;

export interface PratiquesSynthesisResponse {
  clause: DashboardClause;
  grandfather_clause: boolean;
  campaign_year: number | null;
  available_campaign_years: number[];
  available_owners?: PratiquesSynthesisOwnerOption[];
  results: Record<string, Record<string, PratiquesSynthesisSpeciesMetrics>>;
}

export interface PratiquesSynthesisSpeciesMetrics {
  pratiques_count: number;
  total_volume: number;
  has_data_count: number;
  has_fields_count: number;
  has_data_volume: number;
  has_fields_volume: number;
}

export interface DefaultOrganizationRecapRow {
  id: number;
  name: string;
  pratiques_count: number;
  has_data_count: number;
  has_fields_count: number;
}

export interface DefaultOrganizationsRecapResponse {
  clause: DashboardClause;
  campaign_year: number | null;
  organizations: DefaultOrganizationRecapRow[];
}

export enum FormStatusEnum {
  REJECTED = 'REJECTED',
  FINISHED = 'FINISHED',
  INCOMPLETE = 'INCOMPLETE',
  ERROR = 'ERROR',
}
